export class Entry
{
  constructor(public type: string, public title: string, public creator: string,  public metascore: number, public releaseDate: string, public description: string, public image: string){}
}



// WEBPACK FOOTER //
// C:/Users/Dtuck/Desktop/projects/Javascript/metacritic-rebuild/src/models/entry.ts